
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locationSlug]/[merchantSlug]/[merchantId]/dinein-unavailable",
      function () {
        return require("private-next-pages/[locationSlug]/[merchantSlug]/[merchantId]/dinein-unavailable.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locationSlug]/[merchantSlug]/[merchantId]/dinein-unavailable"])
      });
    }
  